export default "__VITE_ASSET__BIkoWSrB__"